import React, { useState } from 'react';

import { Flex } from '../../../components/common/atom/Layout';
import { Text } from '../../../components/common/atom/Text';
import { TextWithTagToBr } from '../../../components/common/molecules/TextWithTagToBr';
import { FractionSwiper } from '../../../components/common/organism/Swiper';
import { ReviewCard } from '../../../components/common/organism/SmallReviewCard';
import ThemeStyle from '../../../lib/style/ThemeStyle';

function doShowReviewImage(reviewItem) {
  return (
    <FractionSwiper>
      {reviewItem.reviewImages.map((reviewImage) => (
        <Flex
          key={reviewImage.id}
          style={{
            overflow: 'hidden',
            borderRadius: '6px',
            height: '13.5rem',
            background: ThemeStyle.background.grey,
          }}
        >
          <img
            src={reviewImage.image.storageUri}
            alt="리뷰 이미지"
            width="100%"
            height="100%"
            style={{ objectFit: 'contain' }}
          />
        </Flex>
      ))}
    </FractionSwiper>
  );
}

function doShowText(singleMode, reviewItem, fullText, setFullText) {
  const shortTextCriteria = 40;

  if (singleMode)
    return (
      <Text
        size={12}
        color="black"
        style={{
          width: '100%',
          marginTop: '0.75rem',
        }}
      >
        {TextWithTagToBr(reviewItem.text)}
      </Text>
    );

  if (reviewItem.text.length <= shortTextCriteria) {
    return (
      <Text
        size={12}
        color="black"
        style={{
          width: '100%',
          marginTop: '0.75rem',
        }}
      >
        {reviewItem.text}
      </Text>
    );
  }

  return (
    <Text
      size={12}
      color="black"
      style={{
        width: '100%',
        marginTop: '0.75rem',
      }}
    >
      {fullText ? (
        TextWithTagToBr(reviewItem.text)
      ) : (
        <>
          {reviewItem.text.substring(0, shortTextCriteria)}
          <Text
            size={12}
            color="brownGrey"
            style={{ cursor: 'pointer' }}
            onClick={() => setFullText(true)}
          >
            ...더보기
          </Text>
        </>
      )}
    </Text>
  );
}

const ReviewItemView = ({ data, singleMode }) => {
  const reviewItem = { ...data };
  // ReviewContext 리팩토링 필요
  const [fullText, setFullText] = useState(false);

  const { id, userName, createDateTime, star, likesCount, text, reviewImages } =
    reviewItem;

  return (
    <Flex column padding="1.25rem 1.25rem 0">
      {doShowReviewImage(reviewItem)}
      <ReviewCard
        id={id}
        userName={userName}
        createDateTime={createDateTime}
        star={star}
        likesCount={likesCount}
        text={text}
        imageUrl={reviewImages[0].image.storageUri}
      >
        {doShowText(singleMode, reviewItem, fullText, setFullText)}
      </ReviewCard>
    </Flex>
  );
};

export default React.memo(ReviewItemView);

ReviewItemView.defaultProps = {
  singleMode: true,
};
